<template>
    <modal ref="modal" unclosable>
        <div id="title" v-html="$t('modals.distributor_max_count_reached.title')"></div>
        <div id="text" v-html="$t('modals.distributor_max_count_reached.text')"></div>
        <button v-on:click="hide">{{ $t('modals.distributor_max_count_reached.button') }}</button>
    </modal>
</template>

<script>
export default {
  methods: {
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    }
  }
}
</script>

<style scoped>

#title {
  color: #000000;
  font-size: 2em;
  font-weight: 400;
  margin: 0 0 1em 0;
}

#text {
  margin: 0 0 1.5em 0;
}

</style>
